import React from "react";
import PropTypes from "prop-types";
import style from "./style.module.scss";
import { Equation } from "@learningblocks/protocol-components/lib/Equation";

/**
 * Content:
 *   - Content for all Tooltip Components
 */
export function Content(props) {
  const className = `${style.content} ${props.className}`;
  return (
    <div className={className}>
      <p>
        <Equation text={props.text} />
      </p>
    </div>
  );
}

Content.propTypes = {
  /**
   * className to set on component
   */
  className: PropTypes.string,
  /**
   * content text
   */
  text: PropTypes.string,
};

Content.defaultProps = {
  text: "",
  className: "",
};
